import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {Angulartics2Module} from 'angulartics2';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CookieService} from 'ngx-cookie-service';
import {NgxMaskModule} from 'ngx-mask';
import {ToastrModule} from 'ngx-toastr';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import { HomeschoolingInitiativeComponent } from './homeschooling-initiative/homeschooling-initiative.component';
import { IntroductionToClassicalEducationComponent } from './introduction-to-classical-education/introduction-to-classical-education.component';
import {PageComponent} from './page/page.component';
import { RecommendedCurriculumComponent } from './recommended-curriculum/recommended-curriculum.component';

@NgModule({
	declarations: [
		AppComponent,
		HomeComponent,
		PageComponent,
		RecommendedCurriculumComponent,
		HomeschoolingInitiativeComponent,
		IntroductionToClassicalEducationComponent,
	],
	entryComponents: [],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule, // required animations module
		ToastrModule.forRoot(), // ToastrModule added
		NgxUiLoaderModule,
		ButtonsModule.forRoot(),
		ModalModule.forRoot(),
		CarouselModule.forRoot(),
		NgxMaskModule.forRoot(),
		StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
		Angulartics2Module.forRoot(),
	],
	exports: [],
	providers: [
		CookieService,
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
